import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { getPageIdFromPathName } from 'helpers/getPageIdFromPathName'
import { NON_ANIMATED_PAGES } from 'root-constants'

export const useRemoveAnimatedBackground = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const currentPageId = getPageIdFromPathName(pathname)
    if (NON_ANIMATED_PAGES.includes(currentPageId)) {
      document.querySelector('canvas')?.remove()
    }
  }, [pathname])
}
